module.exports = __webpack_public_path__ + "img/registrate-perfil.7c003d6c.png";